import React, { useState } from 'react'

import { CardElement } from '@stripe/react-stripe-js'
import classNames from 'classnames/bind'

import { observer } from 'mobx-react'

import styles from './index.module.css'

type CardElementProps = React.ComponentProps<typeof CardElement>

interface Props {
  focused?: boolean
  onReady?: CardElementProps['onReady']
  onChange?: CardElementProps['onChange']
  label: string
}

const cx = classNames.bind(styles)

// TODO: Check why we need these styles to be hardcoded
const INPUT_STYLES = {
  base: {
    fontFamily: '"Inter", sans-serif',
    fontSize: '16px',
  },
}

const Card: React.FC<Props> = ({ focused, onReady, onChange, label }) => {
  const [internalFocused, setInternalFocused] = useState(false)

  const handleFocus = () => setInternalFocused(true)
  const handleBlur = () => setInternalFocused(false)

  const inputClassName = cx('card', { focused: focused || internalFocused })

  return (
    <div className={inputClassName}>
      <label className={styles.label}>{label}</label>
      <CardElement
        onFocus={handleFocus}
        onReady={onReady}
        onChange={onChange}
        onBlur={handleBlur}
        options={{ style: INPUT_STYLES }}
      />
    </div>
  )
}

export default observer(Card)
